import { Page } from "@playwright/test";

/**
 * This utility assigns custom attributes to a component
 *
 * @param page {{Page}}
 * @param selector {string} Used to find the component in the DOM tree
 * @param props {{}} The component props as key/value pairs
 * @returns Promise
 */
export const initComponentProps = async (page: Page, selector: string, props: Record<string, string | number | boolean>) => {
    return await page.evaluate(
        ({ selector, props }) => {
            const component = document.querySelector(selector);
            const camelToKebab = (str: string): string => {
                return str
                    .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
                    .replace(/([A-Z])([A-Z][a-z])/g, "$1-$2")
                    .toLowerCase();
            };
            if (component) {
                Object.entries(props).forEach(([key, value]) => {
                    const attrib = camelToKebab(key);
                    if (typeof value === "boolean") {
                        if (value) {
                            component.setAttribute(attrib, "");
                        } else if (component.hasAttribute(attrib)) {
                            component.removeAttribute(attrib);
                        }
                    } else {
                        component.setAttribute(attrib, `${value}`);
                    }
                });
            }
        },
        { selector, props }
    );
};
